import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

const SharedHeadColumns: React.FC = () => (
  <>
    <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
      <T kind="First name" />
    </th>
    <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
      <T kind="Last name" />
    </th>
    <th className="px-3 py-3.5 text-left text-xs font-semibold text-gray-900 lg:table-cell">
      <T kind="Email address" />
    </th>
  </>
);

export default observer(SharedHeadColumns);
